import React from 'react';

import { useFieldContext, FieldErrors } from '../';
import { Input, Label } from '../../Elements/';

type TextFieldProps = {
	label: string;
	icon?: React.ReactElement;
} & React.InputHTMLAttributes<HTMLInputElement>;

export const TextField = ({ icon, label, ...inputProps }: TextFieldProps) => {
	const field = useFieldContext<string>();

	const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		let newVal = e.target.value;
		if (inputProps.inputMode === 'numeric') {
			// allow only numeric input
			newVal = newVal.replace(/[^0-9.-]+/g, '');
		}
		field.handleChange(newVal);
	};

	// hide the error messages until the field has been touched
	// only show errors after initial blur to prevent the error from displaying when first typing, meta.isBlurred is set to true after initial blur
	const hideErrors = !field.state.meta.isTouched || !field.state.meta.isBlurred;
	const hasErrors = field.state.meta.errors.length > 0 && !hideErrors;

	return (
		<>
			<div className='flex flex-row'>
				<Label htmlFor={field.name} label={label} className='mb-2' />
				{icon}
			</div>
			<Input
				value={field.state.value}
				onChange={onChange}
				onBlur={field.handleBlur}
				{...inputProps}
				name={field.name}
				id={field.name}
				hasErrors={hasErrors}
			/>
			<FieldErrors meta={field.state.meta} name={field.name} hideErrors={hideErrors} />
		</>
	);
};
